import React from 'react';
import styled from '@emotion/styled';
import { getActiveChapter } from './chapterLayouts';

const Row = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 10px 12px 8px;
  background: #1f1f1f;
  scrollbar-width: thin;
  scrollbar-color: #6f6f6f #121212;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: #121212;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #6f6f6f;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--sapGreen);
  }
`;

const Chip = styled.button`
  flex: 0 0 auto;
  border: 0;
  border-radius: 14px;
  padding: 6px 12px;
  cursor: pointer;
  background: ${props => (props.active ? 'var(--sapGreen)' : 'rgba(255, 255, 255, 0.12)')};
  color: ${props => (props.active ? '#fff' : '#e8e8e8')};
  text-align: left;
  max-width: 220px;

  .idx {
    font-size: 9px;
    font-weight: 700;
    opacity: 0.8;
    margin-right: 4px;
  }

  .title {
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    display: inline-block;
    vertical-align: bottom;
  }

  .chapter-time {
    display: block;
    font-size: 10px;
    margin-top: 2px;
    color: #fff;
    opacity: 1;
  }
`;

export default function ChapterChips({ chapters = [], currentTime = '', onChapterClick = () => {} }) {
  if (!chapters.length) return null;
  const activeChapter = getActiveChapter(chapters, currentTime);

  return (
    <Row>
      {chapters.map((section, index) => {
        const isActive = activeChapter?.label === section.label;
        return (
          <Chip key={`${section.label}-${index}`} type="button" active={isActive} onClick={() => onChapterClick(section)}>
            <span className="idx">{index + 1}.</span>
            <span className="title">{section.label}</span>
            <span className="chapter-time">
              {section.start} - {section.end}
            </span>
          </Chip>
        );
      })}
    </Row>
  );
}
